import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=31cdd7e7&scoped=true"
import script from "./Specialty.vue?vue&type=script&lang=js"
export * from "./Specialty.vue?vue&type=script&lang=js"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=31cdd7e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cdd7e7",
  null
  
)

export default component.exports